import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
Vue.use(VueMeta);
const routes = [
  {
    path: "/register",
    name: "register",
    component: () => import("@/page/register"),
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: () => import("@/page/forgetPassword"),
  },
  {
    path: "/newPassword",
    name: "newPassword",
    component: () => import("@/page/forgetPassword/newPassword"),
  },
  {
    path: "/emailCode",
    name: "emailCode",
    component: () => import("@/page/forgetPassword/email"),
  },
  {
    path: "/develop",
    name: "develop",
    component: () => import("@/page/develop"),
  },
  {
    path: "/",
    name: "layout",
    component: () => import("@/page/layout"),
    children: [
      /*  {
        path: "/",
        name: "home",
        component: () => import("@/page/home"),
      },*/

      {
        path: "/",
        name: "newHome",
        component: () => import("@/page/homeList"),
      },
      {
        path: "/demand",
        name: "demand",
        component: () => import("@/page/demand/home.vue"),
      },
      {
        path: "/demand/list",
        name: "demand",
        component: () => import("@/page/demand"),
      },
      {
        path: "/demand/detail",
        name: "demandDetail",
        component: () => import("@/page/demand/detail"),
      },
      {
        path: "/knowledgeZone",
        name: "knowledgeZone",
        component: () => import("@/page/knowledgeZone"),
        children: [
          {
            path: "/knowledgeZone",
            name: "projectZone",
            component: () => import("@/page/knowledgeZone/project"),
          },
          {
            path: "/knowledgeZone/productZone",
            name: "productZone",
            component: () => import("@/page/knowledgeZone/product"),
          },
          {
            path: "/knowledgeZone/technologyZone",
            name: "technologyZone",
            component: () => import("@/page/knowledgeZone/technology"),
          },
        ],
      },
      {
        path: "/mall",
        name: "mallLayout",
        component: () => import("@/page/mall/mallLayout.vue"),
        redirect: "/mall/home",
        children: [
          {
            path: "/mall/home",
            name: "mallLayout",
            component: () => import("@/page/mall/index.vue"),
          },
          {
            path: "/solution",
            name: "solution",
            meta: { title: "解决方案" },
            component: () => import("@/page/solution"),
          },
          {
            path: "/solution/info",
            name: "solutionInfo",
            component: () => import("@/page/solution/info"),
          },
          {
            path: "/solution/ordinary_program",
            name: "ordinary_program",
            component: () => import("@/page/solution/ordinary_program"),
          },
          {
            path: "/solution/internet_things",
            name: "internet_things",
            component: () => import("@/page/solution/internet_things"),
          },
          {
            path: "/service",
            name: "service",
            meta: { title: "服务市场" },
            component: () => import("@/page/service/index"),
          },
          {
            path: "/service/details",
            name: "service_details",
            component: () => import("@/page/service/service_details"),
          },
          {
            path: "/replace",
            name: "replace",
            meta: { title: "IoT硬件" },
            component: () => import("@/page/replace"),
          },
          {
            path: "/replace/info",
            name: "replaceInfo",
            component: () => import("@/page/replace/info"),
          },
          {
            path: "/replace/newInfo",
            name: "replaceNewInfo",
            component: () => import("@/page/replace/newInfo"),
          },
          {
            path: "/replace/productInfo/:type",
            name: "productInfo",
            component: () => import("@/page/replace/productInfo"),
          },
          {
            path: "/treasury",
            name: "treasury",
            meta: { title: "供应商库" },
            component: () => import("@/page/treasury"),
          },
          {
            path: "/treasury/provider",
            name: "provider_details",
            component: () => import("@/page/service/provider_details"),
          },
          {
            path: "/market",
            name: "market",
            meta: { title: "工业互联网" },
            component: () => import("@/page/mall/market/index.vue"),
          },
          {
            path: "/metaService",
            name: "metaService",
            meta: { title: "元服务" },
            component: () => import("@/page/mall/metaService/index.vue"),
          },
        ],
      },
      {
        path: "/ecology",
        name: "ecology",
        meta: { title: "生态创新服务" },
        component: () => import("@/page/ecology/index.vue"),
      },
      {
        path: "/shiXun",
        name: "shiXun",
        component: () => import("@/page/shiXun"),
      },
      {
        path: "/gitIot",
        name: "gitIot",
        component: () => import("@/page/gitIot"),
      },
      {
        path: "/solution/digitizing",
        name: "digitizing",
        component: () => import("@/page/solution/digitizing"),
      },

      {
        path: "/result",
        name: "result",
        component: () => import("@/page/result"),
      },
      {
        path: "/result/info",
        name: "resultInfo",
        component: () => import("@/page/result/info"),
      },
      {
        path: "/activity",
        name: "activity",
        redirect: "/activity/course",
        component: () => import("@/page/activity"),
        children: [
          {
            path: "/activity/course",
            name: "ActivityCourse",
            component: () => import("@/page/activity/course"),
          },
          {
            path: "/activity/activity",
            name: "ActivityActivity",
            component: () => import("@/page/activity/activity"),
          },
        ],
      },
      {
        path: "/activity/courseInfo",
        name: "courseInfo",
        component: () => import("@/page/activity/courseInfo"),
      },
      {
        path: "/activity/activityInfo",
        name: "activityInfo",
        component: () => import("@/page/activity/activityInfo"),
      },
      {
        path: "/activity/courseware",
        name: "courseware",
        component: () =>
          import("@/page/activity/courseware/CoursewareIndex.vue"),
      },
      {
        path: "/activity/courseStatistics",
        name: "courseStatistics",
        component: () =>
          import("@/page/activity/courseStatistics/courseStatisticsIndex.vue"),
      },
      {
        path: "/policy",
        name: "policy",
        component: () => import("@/page/policy"),
      },
      {
        path: "/policy/info",
        name: "policyInfo",
        component: () => import("@/page/policy/info"),
      },
      {
        path: "/searchInfo",
        name: "searchInfo",
        component: () => import("@/page/searchInfo"),
      },
      {
        path: "/questionnaire",
        name: "questionnaire",
        component: () => import("@/page/questionnaire"),
      },
      {
        path: "/protocol",
        name: "protocol",
        component: () => import("@/page/protocol"),
      },
      {
        path: "/protocol/serve",
        name: "protocolServe",
        component: () => import("@/page/protocol/serve"),
      },
      {
        path: "/protocol/tripartite",
        name: "tripartite",
        component: () => import("@/page/protocol/tripartite"),
      },

      {
        path: "/announcement/info",
        name: "announcementInfo",
        component: () => import("@/page/announcement/info"),
      },
      {
        path: "/homeScenes",
        name: "homeScenes",
        redirect: "/homeScenes/list",
        component: () => import("@/page/homeScenes"),
        children: [
          {
            path: "/homeScenes/list",
            name: "list",
            component: () => import("@/page/homeScenes/list"),
          },
          {
            path: "/homeScenes/historyList",
            name: "historyList",
            component: () => import("@/page/homeScenes/historyList"),
          },
          {
            path: "/homeScenes/detail",
            name: "homeScenesDetail",
            component: () => import("@/page/homeScenes/detail"),
          },
          {
            path: "/homeScenes/scenesTopic",
            name: "scenesTopic",
            component: () => import("@/page/homeScenes/scenesTopic"),
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(path) {
    if (
      path.path !== "/knowledgeZone/productZone" &&
      path.path !== "/knowledgeZone/technologyZone" &&
      path.path !== "/knowledgeZone"
    ) {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
